import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/bachelor/assess/page',
    info:'/api-ir/bachelor/assess/get/',
    confirm:'/api-ir/bachelor/assess/confirm/',
    cancel:'/api-ir/bachelor/assess/cancel/'
}

export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}

export function info (teacherId,schoolYear) {
    return baseAPI.axiosData(api.info+teacherId+'/'+schoolYear,'get',null)
}

export function confirm (teacherId,schoolYear) {
    return baseAPI.axiosData(api.confirm+teacherId+'/'+schoolYear,'post',null)
}

export function cancel (teacherId,schoolYear) {
    return baseAPI.axiosData(api.cancel+teacherId+'/'+schoolYear,'post',null)
}